import Vue from "vue";
import Router from "vue-router";
import Layout from "../layout/Layout";

Vue.use(Router);
const _import = require("./_import_" + process.env.NODE_ENV);
console.log(_import, "./_import_" + process.env.NODE_ENV);
export const constantRouterMap = [
	{ path: "/login", component: _import("login/login"), hidden: true },
	{ path: "/", component: Layout, redirect: "/home/index" }
];
export default new Router({
	routes: constantRouterMap
});
export const asyncRouterMap = [
	//首页
	{
		path: "/home",
		component: Layout,
		hidden: true,
		children: [{ path: "index", component: _import("home/index") }]
	},
	//设备管理
	{
		path: "/device",
		component: Layout,
		name: "设备管理",
		children: [
			{ path: "list", component: _import("device/list") }, //列表
			{ path: "add", component: _import("device/add") } //详情
		]
	},
	//项目管理
	{
		path: "/subject",
		component: Layout,
		name: "项目管理",
		children: [
			{ path: "list", component: _import("subject/list") }, //列表
			{ path: "add", component: _import("subject/add") } //详情
		]
	},
	//批处理管理
	{
		path: "/scheduler",
		component: Layout,
		name: "批处理管理",
		children: [
			{ path: "list", component: _import("scheduler/list") }, //列表
			{ path: "info", component: _import("scheduler/info") } //详情
		]
	},
	//运维管理
	{
		path: "/maintenance",
		component: Layout,
		name: "运维管理",
		children: [
			{
				path: "rebacklist",
				component: _import("maintenance/rebacklist")
			}, //意见反馈列表
			{
				path: "articleLlist",
				component: _import("maintenance/articleLlist")
			} //文章列表
		]
	},
	//系统管理
	{
		path: "/setting",
		component: Layout,
		children: [
			{ path: "userManage", component: _import("setting/userManage") }, //人员管理
			{ path: "userEdit", component: _import("setting/userEdit") }, //人员管理
			{ path: "menuManage", component: _import("setting/menuManage") }, //菜单管理
			{ path: "menuEdit", component: _import("setting/menuEdit") }, //菜单管理
			{ path: "roleManage", component: _import("setting/roleManage") }, //角色管理
			{ path: "roleEdit", component: _import("setting/roleEdit") }, //角色管理
			{ path: "dictManage", component: _import("setting/dictManage") }, //菜单管理
			{ path: "dictEdit", component: _import("setting/dictEdit") } //菜单管理
		]
	},
	//路由管理
	{
		path: "/route",
		component: Layout,
		name: "路由管理",
		children: [
			{
				path: "listes",
				component: _import("route/listes")
			} /* 设备管理 */,
			{ path: "info", component: _import("route/info") } /* 设备概览 */,
			{
				path: "deploy",
				component: _import("route/deploy")
			} /* 设备配置 */,
			{
				path: "details/:id",
				component: _import("route/details")
			} /* 设备详情 */
		]
	},
	{ path: "*", redirect: "/404", hidden: true, code: "" }
];



// WEBPACK FOOTER //
// ./src/router/index.js